<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Карты гостей

  .container.mt-5
    .row.search_holder(v-if="!loading")
      .col-12
        .btn.btn-primary.btn-sm(@click="add_search()")
          | Добавить поиск
      .col-12(v-if="searching")
        .searches
          .search(v-for="search of searches")
            .search_bar
              select(v-model="search.search_type")
                option(
                  v-for="(type, index) in search_types",
                  :key="index",
                  :value="type.value"
                )
                  | {{ type.name }}
              template(
                v-if="search_types.find((x) => x.value == search.search_type).search_methods"
              )
                select(v-model="search.search_method")
                  option(
                    v-for="(method, index) in search_types.find((x) => x.value == search.search_type).search_methods.map((x) => search_methods.find((y) => y.value == x))",
                    :key="index",
                    :value="method.value"
                  )
                    | {{ method.name }}
              template(v-else)
                select(v-model="search.search_method")
                  option(
                    v-for="(method, index) in search_methods",
                    :key="index",
                    :value="method.value"
                  )
                    | {{ method.name }}
              template(
                v-if="search_types.find((x) => x.value == search.search_type).enum"
              )
                select(v-model="search.search_query")
                  option(
                    v-for="(sq, index) in search_types.find((x) => x.value == search.search_type).enum",
                    :key="index",
                    :value="sq"
                  )
                    | {{ sq }}
              template(v-else)
                input(
                  v-model="search.search_query",
                  placeholder="Значение",
                  @keyup.enter="do_search"
                )
              //- // remove
              .clear_search(@click="search_reset(search)")
                i.fa.fa-times

        .btn.btn-primary.btn-sm(@click="do_search")
          | Поиск
      .col-12(v-if="searching") Найдено: {{ search_found_amount }}

    .row(v-if="!loading")
      .col
        .pagination.prevPage(
          @click="prevPage",
          :class="{ disabled: cards_page == 0 }"
        )
          i.fa.fa-angle-left
          span Назад
      .col.text-center
        .page_countant
          | Страница {{ cards_page + 1 }} из {{ pages_count }}
      .col
        .pagination.nextPage(
          @click="nextPage",
          :class="{ disabled: pages_count == 1 || pages_count == 0 || pages_count - 1 == cards_page }"
        )
          span Вперед
          i.fa.fa-angle-right

    .row(v-if="!loading")
      .col-6.col-sm-2(v-for="card of cards_display")
        .guest_card(
          :style="{ backgroundColor: cardDesign(card).background_color, color: colorCompare.bestForDisplay({ colors: [cardDesign(card).value_color, cardDesign(card).label_color, '#eee', '#111'], backgroundColor: cardDesign(card).background_color }) }",
          :class="{ notDownloaded: !card.device_type }",
          @click="cardInfo($event, card)"
        )
          .card_number Карта {{ card.client_id }}
          //- .card_id {{ card.id }}
          .card_strip(
            :style="{ backgroundImage: 'url(' + cardDesign(card).strip + ')' }"
          )
            .card_bonuses(
              :style="{ background: 'linear-gradient(-45deg, ' + cardDesign(card).background_color + ', rgba(0,0,0,0))' }"
            )
              .bonuses(v-if="card.last_data.loyalty_type == 1")
                .card_value_amount {{ card.last_data.bonus / 100 }} ₽
                .card_value_percent {{ card.last_data.discount }}%
              .discount(v-else)
                .card_value_percent {{ card.last_data.discount }}%
          .card_name {{ card.last_data.firstname || '' }} {{ card.last_data.lastname || '' }}
          .card_phone {{ card.last_data.phone }}
          .card_email {{ card.last_data.email }}
          .card_labels
            template(v-if="card.device_type == 'ApplePass'")
              ElTooltip(content="Устройство Apple")
                i.fab.fa-apple
            template(v-else-if="card.device_type == 'AndroidPass'")
              ElTooltip(content="Устройство Android")
                i.fab.fa-android
            template(v-else)
              ElTooltip(content="Неизвестное устройство")
                i.far.fa-question-circle

    .row(v-if="loading")
      .col-sm
        .loader_holder(style="margin: 0 auto; width: 200px")
          object(type="image/svg+xml", data="/assets/loaders/infinity.svg")

  .card_data_popup(v-if="selected_card", ref="card_data_popup")
    .heading
      .card_number Карта {{ selected_card.client_id }}
        .blacklisted(
          v-if="blacklist.find((x) => x.phone == selected_card.last_data.phone)"
        )
          i.fa.fa-ban 
          | Заблокирована
      .card_id ID {{ selected_card.id }}
      .close_popup(@click="closePopup()")
        i.fas.fa-times
    .body
      .main_data
        .title Основная информация
        .field ID заведения&nbsp;
          .value {{ selected_card.user_id || '—' }}
        .field ID шаблона&nbsp;
          .value {{ selected_card.template_id || '—' }}
        .field Тип устройства&nbsp;
          .value {{ selected_card.device_type || '—' }}
        .field Сериальный номер&nbsp;
          .value {{ selected_card.serial_number || '—' }}
        .field Токен устройства&nbsp;
          .value {{ selected_card.device_token || '—' }}
        .field Токен&nbsp;
          .value {{ selected_card.token || '—' }}
        .field Время создания&nbsp;
          .value {{  moment(selected_card.createdAt).format("DD.MM.YYYY в HH:mm:ss") || '—'  }}
        .field Последнее обновление&nbsp;
          .value {{  moment(selected_card.updatedAt).format("DD.MM.YYYY в HH:mm:ss") || '—'  }}
      .additional_data(v-if="selected_card.last_data")
        .title Последние данные
        .field Фамилия&nbsp;
          .value {{ selected_card.last_data.lastname || '—' }}
        .field Имя&nbsp;
          .value {{ selected_card.last_data.firstname || '—' }}
        .field ID гостя&nbsp;
          .value {{ selected_card.last_data.client_id || '—' }}
        .field Номер карты&nbsp;
          .value {{ selected_card.last_data.card_number || selected_card.last_data.client_id || '—' }}
        .field Телефон&nbsp;
          .value {{ selected_card.last_data.phone || '—' }}
        .field E-mail&nbsp;
          .value {{ selected_card.last_data.email || '—' }}
        .field Дата рождения&nbsp;
          .value {{ selected_card.last_data.birthday || '—' }}
        .field Пол&nbsp;
          .value {{ selected_card.last_data.client_sex == 1 ? 'Мужчина' : selected_card.last_data.client_sex == 2 ? 'Женщина' : 'Неизвестно' }}
        .filed ID группы&nbsp;
          .value {{ selected_card.last_data.client_group_id || '—' }}
        .field Тип лояльности&nbsp;
          .value {{ selected_card.last_data.loyalty_type == 1 ? 'Бонусы' : 'Скидка' }}
        template(v-if="selected_card.last_data.loyalty_type == 2")
          .field Скидка группы&nbsp;
            .value {{ selected_card.last_data.client_group_discount || '—' }}%
          .field Скидка гостя&nbsp;
            .value {{ selected_card.last_data.discount || '—' }}%
        template(v-else)
          .field Кешбек группы&nbsp;
            .value {{ selected_card.last_data.client_group_discount || '—' }}%
          .field Кешбек гостя&nbsp;
            .value {{ selected_card.last_data.discount || '—' }}%
          .field Количество бонусов&nbsp;
            .value {{ selected_card.last_data.bonus || '—' }} / 100 бон.
        .field Сумма трат гостя&nbsp;
          .value {{ selected_card.last_data.total_payed_sum || '—' }} / 100 ₽
        .field Последний пуш:&nbsp;
          .value {{ selected_card.last_data.last_message || '—' }}
    .pushes_stats
      .pushes
        .push(v-for="push of pushes")
          template(v-if="push.type == 'push'")
            ElTooltip(
              :content="`Мы отправили пуш на карту ${moment(push.createdAt).format('DD.MM.YYYY HH:mm:ss')}`"
            )
              i.fas.fa-paper-plane

          template(v-if="push.type == 'download'")
            ElTooltip(
              :content="`Устройство скачало карту ${moment(push.createdAt).format('DD.MM.YYYY HH:mm:ss')}`"
            )
              i.fas.fa-cloud-download-alt
      .status(:class="{ [pushes_status]: true }") 
        span(v-if="pushes_status == 'loading'") Загрузка статистики
        span(v-if="pushes_status == 'ok'") Карта получает обновления
        span(v-if="pushes_status == 'bad'") Карта не получает обновления
</template>

<script>
import { Tooltip } from "element-ui";
import apiDriver from "../../apiDriver";
import moment from "moment";
let colorCompare = require("../../colorCompare").default;

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      blacklist: [],
      loading: true,
      cards: [],
      cards_display: [],
      cards_paginated: [],
      cards_page_size: 100,
      cards_page: 0,
      pages_count: 0,
      designs: [],
      default_design: {
        id: 0,
        name: "Не выбран",
      },
      selected_card: null,
      pushes: [],
      pushes_status: "loading",

      search_types: [
        { name: "Номер карты", value: "client_id" },
        { name: "ID Карты", value: "id" },
        {
          name: "Имя владельца",
          value: "last_data.firstname",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "Фамилия владельца",
          value: "last_data.lastname",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "Имя и фамилия владельца",
          value: "custom.fullname",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "Телефон",
          value: "last_data.phone",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "E-mail",
          value: "last_data.email",
          search_methods: ["=", "!=", "like"],
        },
        { name: "Группа гостя", value: "last_data.client_group_id" },
        {
          name: "Тип лояльности",
          value: "last_data.loyalty_type",
          enum: [1, 2],
          search_methods: ["=", "!="],
        },
        {
          name: "Токен устройства",
          value: "device_token",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "Тип устройства",
          value: "device_type",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "Количество бонусов (в копейках)",
          value: "last_data.bonus",
          search_methods: ["=", "!=", ">=", "<=", ">", "<"],
        },
        {
          name: "% Кешбека",
          value: "last_data.discount",
          search_methods: ["=", "!=", ">=", "<=", ">", "<"],
        },
        {
          name: "Скидка",
          value: "last_data.discount",
          search_methods: ["=", "!=", ">=", "<=", ">", "<"],
        },
        {
          name: "Сумма трат гостя",
          value: "last_data.total_payed_sum",
          search_methods: ["=", "!=", ">=", "<=", ">", "<"],
        },
        {
          name: "Последний пуш",
          value: "last_data.last_message",
          search_methods: ["=", "!=", "like"],
        },
        {
          name: "Карта установлена",
          value: "custom.card_installed",
          enum: ["Да", "Нет"],
          search_methods: ["=", "!="],
        },
      ],
      search_methods: [
        { name: "равно", value: "=" },
        { name: "не равно", value: "!=" },
        { name: "содержит", value: "like" },
        { name: "больше", value: ">" },
        { name: "больше или равно", value: ">=" },
        { name: "меньше", value: "<" },
        { name: "меньше или равно", value: "<=" },
      ],

      searches: [],
      searching: false,
      search_found_amount: 0,
      colorCompare,
    };
  },

  computed: {},

  async mounted() {
    this.loading = true;
    await this.getCards();
    await this.loadCardTemplates();
    await this.loadBanned();
    this.loading = false;
  },

  methods: {
    moment,
    searchInSubSearch(cards, search) {
      let search_key;
      let search_results = [];
      let search_array = [];

      console.log("search_type", this.search_type);

      // подготовка к поиску, индексация массива
      if (search.search_type.includes("custom.")) {
        if (search.search_type == "custom.fullname") {
          search_key = "fullname";
          search_array = cards.map((card) => ({
            id: card.id,
            fullname: card.last_data.firstname + " " + card.last_data.lastname,
          }));
        }
        if (search.search_type == "custom.card_installed") {
          search_key = "card_installed";
          search_array = cards.map((card) => ({
            id: card.id,
            card_installed: !!card.device_token ? "Да" : "Нет",
          }));
        }
      } else if (search.search_type.includes("last_data.")) {
        search_key = search.search_type.split(".")[1];
        search_array = cards.map((card) => ({
          ...card.last_data,
          id: card.id,
        }));
      } else {
        search_key = search.search_type;
        search_array = cards;
      }

      console.log("search_key", search_key);
      console.log("search_array", search_array);
      console.log("search_query", search.search_query);
      console.log("search_method", search.search_method);

      // выполнение методов поиска
      if (search.search_method == "like") {
        search_results = search_array.filter((card) =>
          card[search_key]
            .toString()
            .toLowerCase()
            .includes(search.search_query.toLowerCase())
        );
      }
      if (search.search_method == "=") {
        search_results = search_array.filter(
          (card) => card[search_key] == search.search_query
        );
        console.log(`card.${search_key} == ${search.search_query}`);
      }
      if (search.search_method == "!=") {
        search_results = search_array.filter(
          (card) => card[search_key] != search.search_query
        );
        console.log(`card.${search_key} != ${search.search_query}`);
      }
      if (search.search_method == ">") {
        search_results = search_array.filter(
          (card) => Number(card[search_key]) > Number(search.search_query)
        );
        console.log(`card.${search_key} > ${search.search_query}`);
      }
      if (search.search_method == ">=") {
        search_results = search_array.filter(
          (card) => Number(card[search_key]) >= Number(search.search_query)
        );
        console.log(`card.${search_key} >= ${search.search_query}`);
      }
      if (search.search_method == "<") {
        search_results = search_array.filter(
          (card) => Number(card[search_key]) < Number(search.search_query)
        );
        console.log(`card.${search_key} < ${search.search_query}`);
      }
      if (search.search_method == "<=") {
        search_results = search_array.filter(
          (card) => Number(card[search_key]) <= Number(search.search_query)
        );
        console.log(`card.${search_key} <= ${search.search_query}`);
      }

      // получение id найденных объектов
      let search_results_ids = search_results.map((card) => card.id);

      console.log("search_results_ids", search_results_ids);

      return search_results_ids;
    },
    do_search() {
      let cards = this.cards;
      let search_results_ids = [];

      // поиск в поисках
      for (let search of this.searches) {
        let new_ids = this.searchInSubSearch(cards, search);
        search_results_ids = new_ids;
        cards = cards.filter((card) => new_ids.includes(card.id));
      }

      // отображение карт с найденными id
      this.cards_paginated = cards.filter((card) =>
        search_results_ids.includes(card.id)
      );
      this.search_found_amount = search_results_ids.length;
      this.openCardsPage(0);
    },
    add_search() {
      this.searches.push({
        id: Math.random(),
        search_type: "client_id",
        search_method: "=",
        search_query: "",
      });
      this.searching = true;
    },
    search_reset(search) {
      this.searches = this.searches.filter((x) => x.id != search.id);
      if (this.searches.length == 0) {
        this.cards_paginated = this.cards;
        this.openCardsPage(0);
        this.searching = false;
      }
    },
    async cardInfo(e, card) {
      this.pushes_status = "loading";
      console.log(e, card);
      this.selected_card = JSON.parse(JSON.stringify(card));
      this.pushes = [];
      let stats = await apiDriver.services.api.get(
        "cards",
        "cards/checkDownloads",
        {
          card_id: this.selected_card.id,
        }
      );
      let stat = stats.data.stat;
      this.pushes = stat;
      this.pushes_status = stat.find((x) => x.type == "download")
        ? "ok"
        : "bad";
      console.log("stat", stat);
    },
    closePopup() {
      this.selected_card = null;
    },
    cardDesign(card) {
      if (card.template_id == 108) {
        return {
          id: 108,
          background_color: "rgb(54, 4, 0)",
          label_color: "#ffffff",
          value_color: "#ffffff",
        };
      }
      return (
        this.designs.find((design) => design.id == card.template_id) ||
        this.default_design
      );
    },
    async loadCardTemplates() {
      let x = (
        await apiDriver.services.api.get("cards", "settings/userCardTemplates")
      ).data;
      for (let d of x.templates) d.minified = true;
      this.designs = x.templates;
      this.default_design = this.designs[0];
      console.log("designs", this.designs);
    },
    async getCards() {
      let cards = await apiDriver.services.api.get("cards", "cards");
      let cards_list = cards.data.list;
      //pagination by params page and pages
      for (
        let current_page = cards.data.page;
        current_page < cards.data.pages;
        current_page++
      ) {
        let cards_page = await apiDriver.services.api.get("cards", "cards", {
          page: current_page + 1,
        });
        cards_list = cards_list.concat(cards_page.data.list);
      }
      console.log("cards", cards.data.list);
      this.cards = cards_list;
      this.cards_paginated = this.cards;
      this.openCardsPage(0);
    },
    openCardsPage(page) {
      this.cards_page = page;
      this.cards_display = this.cards_paginated.slice(
        page * this.cards_page_size,
        (page + 1) * this.cards_page_size
      );
      this.pages_count = Math.ceil(
        this.cards_paginated.length / this.cards_page_size
      );
    },
    prevPage() {
      if (this.cards_page > 0) this.openCardsPage(this.cards_page - 1);
    },
    nextPage() {
      if (
        this.cards_page <
        Math.ceil(this.cards_paginated.length / this.cards_page_size) - 1
      )
        this.openCardsPage(this.cards_page + 1);
    },
    async loadBanned() {
      let loadBanned = await apiDriver.services.api.get(
        "cards",
        "settings/banned"
      );
      this.blacklist = loadBanned.data.list;
      console.log("blacklist", this.blacklist);
    },
  },
};
</script>

<style lang="stylus" scoped>
.search_holder {
  .searches {
    .search {
      display: block;
      overflow: hidden;

      .clear_search {
        cursor: pointer;
        opacity: 0.5;
        display: inline-block;
        margin-left: 10px;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

.pagination {
  margin: 20px 10px;
  display: inline-block;
  // no select
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  // border: 1px solid #eee;
  // padding: 10px 20px;
  &.nextPage {
    float: right;

    i {
      margin-left: 5px;
    }
  }

  &.prevPage {
    i {
      margin-right: 5px;
    }
  }

  &:hover {
    color: #3f51b5;
    cursor: pointer;
  }

  &.disabled {
    color: #bdbdbd;
    cursor: default;
  }
}

.page_countant {
  margin: 15px 10px;
  color: gray;
}

.card_data_popup {
  position: fixed;
  top: 0;
  width: 450px;
  background: #fff;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  border-radius: 0;
  right: 0;
  height: 100vh;
  z-index: 999;

  .heading {
    padding: 10px;
    height: 90px;

    .card_number {
      font-size: 1.5rem;
      font-weight: bold;

      .blacklisted {
        display: inline-block;
        font-size: 10px;
        background: #f44336;
        color: white;
        font-weight: bold;
        padding: 3px 10px;
        border-radius: 8px;
        position: relative;
        top: -5px;
        margin-left: 10px;
        text-transform: uppercase;
        font-family: 'Open Sans' !important;

        i {
          margin-right: 5px;
        }
      }
    }

    .card_id {
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .close_popup {
      position: absolute;
      right: 14px;
      top: 10px;
      cursor: pointer;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }
    }
  }

  .body {
    padding: 10px;
    padding-top: 0;
    overflow: hidden;
    overflow-y: scroll;
    height: calc(100vh - 90px);
    padding-bottom: 60px;

    .field {
      margin-top: -5px;
      overflow: hidden;
    }

    .value {
      &:before {
        content: ' ';
      }

      display: inline-block;
      margin-left: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 220px;
      position: relative;
      top: 5px;
      font-family: 'IBM Plex Mono', monospace;
      font-weight: bold;
    }

    .additional_data {
      margin-top: 10px;
    }
  }

  .pushes_stats {
    position: fixed;
    bottom: 0;
    background: white;
    border-top: 2px solid #eee;
    padding: 5px 12px;

    .pushes {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 425px;

      .push {
        .fa-cloud-download-alt {
          color: #2196f3;
        }

        .fa-paper-plane {
          color: #c7c7c7;
        }
      }
    }

    .status {
      font-size: 9pt;

      &.loading {
        color: gray;
      }

      &.ok {
        color: #1072bf;
      }

      &.bad {
        color: red;
      }
    }

    .push {
      display: inline-block;
    }
  }
}

.guest_card {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
  position: relative;
  padding: 8px 0px;
  overflow: hidden;

  .card_id {
    position: absolute;
    right: 10px;
    top: 7px;
    opacity: 0.5;

    &:hover {
      color: white;
      opacity: 1;
    }
  }

  .card_number {
    padding: 0px 8px;
  }

  .card_strip {
    margin: 4px 0px;
    height: 50px;
    background-position: center;
    background-size: 200px;
    background-repeat: no-repeat;
  }

  .card_name {
    padding: 0px 8px;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .card_phone {
    padding: 0px 8px;
  }

  .card_email {
    padding: 0px 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .card_bonuses {
    text-align: right;
    height: 50px;
    display: block;
    padding-right: 10px;
    width: 200%;
    left: -100%;
    position: relative;

    .bonuses {
      font-weight: bold;
      font-size: 10pt;
      padding-top: 7px;

      .card_value_percent {
        font-size: 8pt;
        margin-top: -2px;
      }
    }

    .discount {
      line-height: 50px;
      font-size: 16pt;
      font-weight: 500;
    }
  }

  .card_labels {
    padding: 0px 8px;
    margin-top: 0px;
    margin-bottom: -4px;
  }

  &.notDownloaded {
    background: gray !important;
    color: white !important;

    .card_strip {
      background: #6e6e6e !important;
    }

    .card_bonuses {
      background: linear-gradient(-45deg, gray, rgba(0, 0, 0, 0)) !important;
    }
  }
}
</style>

<style scoped lang="stylus">
div {
  cursor: default;
}

a {
  margin-bottom: 2px;
  background: #3f51b5;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;

  &:hover {
    color: white;
  }

  &:focus {
    color: white;
  }
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

button.styled {
  margin-bottom: 5px;
  border: 1px solid #6c68cb;
  padding: 10px 15px;
  border-radius: 4px;
  color: #464384;
  cursor: pointer;
  background: white;

  &:hover {
    background: #6c68cb;
    color: white;
  }

  &[disabled] {
    border-color: #ddd;
    color: #ddd;
    cursor: default;
    background: white;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.design {
  background: white;
}

.inputModule {
  margin-bottom: 10px;

  &.extended {
    border-left: 4px solid #f4f3ef;
    padding-left: 15px;
    margin-left: 10px;
    padding-top: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .card_data_popup {
    width: 100vw;
    box-shadow: none;
  }
}

@media (prefers-color-scheme: dark) {
  .card_data_popup {
    background: #141414;
    color: white;

    .pushes_stats {
      background: #141414;
      border-top: 2px solid #000;

      .pushes {
        .push {
          .fa-cloud-download-alt {
            color: #2196f3;
          }

          .fa-paper-plane {
            color: #c7c7c7;
          }
        }
      }
    }
  }
}
</style>
